import { useEffect, useState } from "react";
import { MainPageBase } from "../page-bases/MainPageBase";
import { NoItemContent } from "../page-bases/NoItemContent";
import { Box, Divider, Stack } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import DamsTable from "../../components/Table/CollapsibleTable";
import { TRowItem } from "../../components/Table/TableRow";
import { assetApi } from "../../services/assets/asset-crud";
import { useMangeTableItems } from "../../hooks/useManageTableItems";
import { useDmsForm } from "../../hooks/useDmsFrom";
import { usePagination } from "../../hooks/usePagination";
import { assetBatchDistributionApi } from "../../services/distribution/asset-distribution";
import { actionDialogStore, alertDialogStore } from "../../store/dialogs";
import { useAppDispatch, useAppSelector } from "../../store/hooks";

import { updateBatchDistributionCart } from "../../store/reducers/distribution/distributedRecordStore";
import { AssetLogsFilter } from "../../common-ui/page-filters";
import {
  IAssetRecord,
  ICreateAssetDistribution,
  IPagination,
  IQueryPerams,
} from "../../config/types";
import { formatDate } from "../../utils/common";
import { DomainSelectInput } from "../../common-ui/select-input-models/DomainSelectInput";
import { Field } from "../../utils/formSchema";
import { dmsDomainsNamesTy } from "../../config/constants/domain";
import appRoutePath from "../../config/path";
function UpdateBatchDistributionPage() {
  const [pageState, setPageState] = useState<string>("main");
  const [dataset, setDataset] = useState<TRowItem[]>([]);
  const [isProcessing, setProcess] = useState<boolean>(false);
  const { id } = useParams<{ id: string }>();
  const entryDetail = useAppSelector((data) => data.batchDistributionCart);
  const {
    pagination,
    paginateToNextPage,
    paginateToPreviousPage,
    paginateToPageNumber,
    updatePaginationInitState,
  } = usePagination<any>(assetApi.getAssets);
  const dispatch = useAppDispatch();
  const { form, updateForm, setSubmitAttempt, isFormValid, getFormValues } =
    useDmsForm<Partial<ICreateAssetDistribution>>({
      from_location_id: entryDetail.from_location_id,
      from_location_domain: entryDetail.from_location_domain,
      to_location_domain: entryDetail.to_location_domain,
      to_location_id: entryDetail.to_location_id,
      assets: [],
    });
  const { selectedRowItems, toggleRow, toggleSelectAllRow } =
    useMangeTableItems(dataset);
 
  const [querySet, setQuerySet] = useState<IQueryPerams>({ is_deleted: false });
  const populateDataSet = (data: IAssetRecord[], pagination?: IPagination) => {
    const formatData = data.map((data) => ({
      ...data,
      date_received: formatDate(data.date_received),
      asset_meta_raw: data.asset_meta
        ? data.asset_meta.map(
            (item) => ` ${item.asset_tag}=${item.meta_value} `
          )
        : [],
    }));

    setDataset(formatData);
    updatePaginationInitState(pagination);
  };

  const fetchData = async () => {
    const result = await assetApi.getAssets({ is_deleted: false ,is_assigned:false});
    if (result?.data) {
      populateDataSet(result.data, result.pagination);
    }
    const distributionDetail =
      await assetBatchDistributionApi.getBatchDistribution(id ?? "");
    if (distributionDetail.data) {
      dispatch(updateBatchDistributionCart(distributionDetail.data));
      const {
        from_location_id,
        from_location_domain,
        to_location_id,
        to_location_domain,
      } = distributionDetail.data;
      updateForm({
        from_location_domain: { value: from_location_domain, isValid: true },
        from_location_id: { value: from_location_id, isValid: true },
        to_location_domain: { value: to_location_domain, isValid: true },
        to_location_id: { value: to_location_id, isValid: true },
      });
    }
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    updateForm((prev) => ({
      ...prev,
      assets: {
        value: selectedRowItems.map((row) => row.id),
        isValid: selectedRowItems.length > 0,
      },
    }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedRowItems.length]);

  const navigate = useNavigate();
  function addNewItem() {}
  function cancelAddItem() {}
  function clearSearch() {
    setPageState("empty-db");
  }
  async function onSaveItemClick() {
    actionDialogStore.open({
      title: "Update Asset Batch Distribution",
      subtitle: `You are about  Update with ${selectedRowItems.length} assets. Click 'Confirm' to continue.`,
      onRightBtnPress: async () => confirmUserSave(),
    });
  }
  async function confirmUserSave() {
    setSubmitAttempt(true);
    if (isFormValid()) {
      setProcess(true);
      const data = getFormValues();
      const result = await assetBatchDistributionApi.updateBatchDistribution(
        entryDetail.id ?? "",
        data
      );
      alertDialogStore.open({
        title: "Asset Batch Distribution Update",
        subtitle: result.message,
        onRightBtnPress: () => {},
        rightBtnTxt: "Okay",
        onLeftBtnPress: onSeeAllPress,
        leftBtnTxt: "See All",
        isSuccess: result.success,
      });
      if(result.success){
        await fetchData()
      }
    } else {
      if (!form?.assets?.isValid) {
        alertDialogStore.open({
          title: "Asset Selection is Required",
          subtitle:
            "Please select atleast one Asset from table  below to continue",
          onRightBtnPress: () => {},
          rightBtnTxt: "Okay",
          onLeftBtnPress: () => {},
          leftBtnTxt: "Close",
          isSuccess: false,
        });
      }
    }
  }
  function onSeeAllPress() {
    navigate(appRoutePath.OUTBOUND_ASSET_DISTRIBUTIONS_PAGE);
  }

  function handleToDomainSelect(item: Field, domain: dmsDomainsNamesTy) {
    updateForm((p) => ({
      ...p,
      to_location_id: item,
      to_location_domain: { value: domain, isValid: true },
    }));
  }

  function handleFromDomainSelect(item: Field, domain: dmsDomainsNamesTy) {
    updateForm((p) => ({
      ...p,
      from_location_id: item,
      from_location_domain: { value: domain, isValid: true },
    }));
  }
  if (!form.from_location_domain?.isValid===true) {
    return null;
  }
 
  return (
    <MainPageBase
      pageState={"add-item"}
      title={`Update  Batch Distribution Record`}
      addItemBtnOnClick={onSaveItemClick}
      addItemBtnText={"Add Users"}
      cancelBtnClick={() => cancelAddItem()}
    >
      <Box
        height={`100%`}
        display={"flex"}
        alignItems={pageState !== "main" ? "center" : ""}
        justifyContent={"center"}
      >
        {pageState !== "main" ? (
          <NoItemContent
            type={pageState}
            title={""}
            subtitle={""}
            addItemBtn={() => addNewItem()}
            clearSearchBtn={() => clearSearch()}
          />
        ) : (
          <Stack width={"100%"}>
            <Stack
              display={"flex"}
              spacing={3}
              direction={"row"}
              width={"100%"}
              minHeight={180}
            >
              <Box width={320}>
                <DomainSelectInput
                  direction="column"
                  label="Distributor  Domain Name"
                  placeholder="Select Distributor  Domain Name"
                  handleChange={handleFromDomainSelect}
                  value={{
                    domain_id: form.from_location_id?.value,
                    domain_name: form.from_location_domain?.value,
                  }}
                />
              </Box>
              <Divider orientation="vertical" />
              <Box width={320}>
                <DomainSelectInput
                  direction="column"
                  placeholder="Select Recipent Domain Name"
                  label="Recipent Domain Name"
                  handleChange={handleToDomainSelect}
                  value={{
                    domain_id: form.to_location_id?.value,
                    domain_name: form.to_location_domain?.value,
                  }}
                />
              </Box>
            </Stack>

            <AssetLogsFilter<IAssetRecord[]>
              ftn={assetApi.getAssets}
              updateDataSet={populateDataSet}
              updateQuerySet={setQuerySet}
              isAssigned={false}
              isDeleted={false}
            />

            <DamsTable
              tableTitle={"New Assets"}
              tableSubtitle={""}
              tableTitleBadge={
                selectedRowItems.length === 0
                  ? ""
                  : ` ${selectedRowItems.length} Assets selected to added to this distribution`
              }
              tableHeaders={columns}
              data={dataset}
              tableKeys={tkeys}
              useTableCheckbox={true}
              selectedRowItems={selectedRowItems}
              onTableItemSelect={toggleRow}
              toggleSelectAllRow={toggleSelectAllRow}
              hasPagination
              paginationState={pagination}
              onNextPage={paginateToNextPage(querySet, populateDataSet)}
              onPreviousPage={paginateToPreviousPage(querySet, populateDataSet)}
              setActivePage={paginateToPageNumber(populateDataSet, querySet)}
            />
          </Stack>
        )}
      </Box>
    </MainPageBase>
  );
}

const tkeys = [
  "asset_category_name",
  "serial_number",
  "brand",
  "embossment_number",
  "assigned",
  "warranty_in_months",
];

const columns = [
  "Asset Category",
  "Serial Number",
  "Brand",
  "Embossment Number",
  "Assigned",
  "warranty (months)",
];
export { UpdateBatchDistributionPage };
